import { render, staticRenderFns } from "./PurPrepaymentList.vue?vue&type=template&id=5fe0386c&scoped=true&"
import script from "./PurPrepaymentList.vue?vue&type=script&lang=js&"
export * from "./PurPrepaymentList.vue?vue&type=script&lang=js&"
import style0 from "./PurPrepaymentList.vue?vue&type=style&index=0&id=5fe0386c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe0386c",
  null
  
)

export default component.exports